import { PATHS } from '@dadohr/shared/domainTypes/routes';
import { IconButton, Tooltip } from '@material-ui/core';
import { UserPlus as IconImpersonate } from 'lucide-react';
import React from 'react';
import { AppLink } from '../AppLink';

export const ImpersonationLink: React.FC<{ orgId: string }> = ({
  orgId,
  children
}) => {
  return (
    <AppLink pathname={PATHS.home.overview} query={{ orgId }}>
      {children || 'Impersonate'}
    </AppLink>
  );
};

export const ImpersonationLinkIcon: React.FC<{
  orgId: string;
  size?: number | string;
}> = ({ orgId, size }) => {
  return (
    <ImpersonationLink orgId={orgId}>
      <Tooltip title="Impersonate">
        <IconButton>
          <IconImpersonate size={size} />
        </IconButton>
      </Tooltip>
    </ImpersonationLink>
  );
};
